import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import { type HTMLTableRowProps } from '@/lib/types';
import isTouchDevice from '@/lib/utils/isTouchDevice';
import stripProps from '@/lib/utils/stripProps';
import styled from '@emotion/styled';

type StyledItemTableRowProps = HTMLTableRowProps & {
  selected: boolean;
};

const StyledItemTableRow = styled(
  stripProps('tr', 'selected'),
)<StyledItemTableRowProps>(
  ({ theme, selected }) => ({
    height: 37,
    backgroundColor: selected ? theme.palette.action.hover : undefined,
    borderBottom: `1px solid ${theme.palette.action.selected}`,
    transition: theme.transitions.create(['background-color']),
    ':last-of-type': {
      borderBottom: 'none',
    },
    '> td:first-of-type': {
      overflow: 'hidden',
    },
    '.MuiCheckbox-root': {
      marginTop: -9,
      marginBottom: -9,
      marginLeft: -9,
    },
    '.MuiCheckbox-root:not(.Mui-checked):not(:focus-within)': {
      opacity: isTouchDevice() ? undefined : 0,
    },
    ':hover': {
      backgroundColor: selected
        ? theme.palette.action.selected
        : theme.palette.action.hover,
      '.MuiCheckbox-root': {
        opacity: '1 !important',
      },
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    borderBottomColor: theme.palette.divider,
  })),
);

export default StyledItemTableRow;
